import React from 'react';
import styles from './styles.module.scss';
import FirmLogo from 'common/components/FirmLogo';
import MenuItemUser from '../MenuItemUser';
import ModalContactSupport from "../../../../common/components/ModalContactSupport";

const HeaderNavView = () => {

  return (
    <div className={styles.navbar}>
      <nav className={styles.nav}>
        <MenuItemUser/>
        <ModalContactSupport
        />
      </nav>
      <FirmLogo/>
    </div>
  );
};

export default HeaderNavView;
